import { Dialog, Grid, IconButton } from '@mui/material';
import Images from '../../../Utils/images';
import CustomButton from '../../../Components/CustomButton';
import { useTranslation } from 'react-i18next';

import { memo, useEffect, useMemo, useState } from 'react';
import {
  checkDeliverability,
  getSchdules,
  orderLocationMethod,
} from '../../../redux/riskCenterSlice';
import { RootState, useAppSelector } from '../../../redux/store';
import { useNavigate } from 'react-router-dom';
import { riskBranchId } from '../../../api';
import AutoCompleteLocation from '../../../Components/AutoCompleteLocation';
import { useForm } from 'react-hook-form';
import {
  getAddress,
  getCurrentLocation,
  isSafari,
} from '../../../Utils/helperFns';
import NoData from '../../../Components/Nodata';
import { setSelectedAddress } from '../../../redux/commonSlice';
import SearchInput from '../../../Components/SearchComponent';
import ToolTipComponent from '../../../Components/ToolTipComponent';
import LocationDeniedModal from '../../../Components/LocationDeniedModal';

interface Props {
  open: boolean;
  handleClose?: any;
  type?: string;
  pickupType?: string;
}
function SelectAddressDialog(props: Props) {
  const { open, handleClose, type, pickupType } = props;
  const navigate = useNavigate();
  const [latLong, setLatLong] = useState<any>(null);
  const [searchKey, setSearchKey] = useState('');
  const [debouncedSearchKey, setDebouncedSearchKey] = useState('');
  const [openLocationDeniedModal, setOpenLocationDeniedModal] = useState(false);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchKey(searchKey.toLowerCase());
    }, 300); // debounce delay in ms

    return () => {
      clearTimeout(handler);
    };
  }, [searchKey]);

  const { businessAddress, loader, cabService } = useAppSelector(
    (state: RootState) => state.riskCenter,
  );

  const { selectedAddress } = useAppSelector(
    (state: RootState) => state.common,
  );

  const [addressType, setAddressType] = useState('BUSINESS');
  const { t: tC } = useTranslation('translation', {
    keyPrefix: 'Common',
  });
  const { t } = useTranslation('translation', {
    keyPrefix: 'orders.change_location',
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    getValues,
    trigger,
    reset,
  } = useForm({
    // resolver: yupResolver(AddOrderSchema),
    mode: 'all',
    defaultValues: {
      address: selectedAddress?.productionName
        ? `${selectedAddress?.productionName}, ${
            selectedAddress?.episodeNumber && selectedAddress?.episodeName
              ? `${selectedAddress?.episodeNumber} - ${selectedAddress?.episodeName}, `
              : ''
          } ${selectedAddress?.setName}, ${selectedAddress?.locationName}`
        : selectedAddress?.locationName || '',
    },
  });

  useEffect(() => {
    if (!selectedAddress?.locationName) {
      if (!isSafari) {
        fetchLocation();
      }
    } else {
      setValue(
        'address',
        selectedAddress?.productionName
          ? `${selectedAddress?.productionName}, ${
              selectedAddress?.episodeNumber && selectedAddress?.episodeName
                ? `${selectedAddress?.episodeNumber} - ${selectedAddress?.episodeName}, `
                : ''
            } ${selectedAddress?.setName}, ${selectedAddress?.locationName}`
          : selectedAddress?.locationName || '',
      );
    }
  }, [getValues('address')]);

  const businessAddresses = businessAddress?.data
    ?.filter((item: any) => item.addressType === addressType)
    ?.reverse();

  const handleLocation = (data: any) => {
    if (type !== 'cabService') {
      orderLocationMethod(data);
      checkDeliverability({
        latitude: data?.location?.coordinates?.[1],
        longitude: data?.location?.coordinates?.[0],
        branchId: riskBranchId,
      });
      getSchdules(`?productionId=${data?.productionId}&setId=${data?.setId}`);
      handleClose && handleClose();
    } else {
      // updateCabService(pickupType, {
      //   ...data,
      //   coordinates: {
      //     type: 'Point',
      //     coordinates: [
      //       data?.location?.coordinates[1],
      //       data?.location?.coordinates[0],
      //     ],
      //   },
      // })
      setValue(
        'address',
        `${data?.productionName}, ${
          data?.episodeNumber && data?.episodeName
            ? `${data?.episodeNumber} - ${data?.episodeName}, `
            : ''
        } ${data?.setName}, ${data?.locationName}`,
      );

      setSelectedAddress({
        ...data,
        coordinates: {
          type: 'Point',
          coordinates: [
            data?.location?.coordinates[1],
            data?.location?.coordinates[0],
          ],
        },
      });
      handleClose();
    }
  };

  const fetchLocation = async (click: any) => {
    try {
      // const cachedLocation = localStorage.getItem('userLocation');
      // if (cachedLocation) {
      //   let loc = JSON.parse(cachedLocation);
      //   // setLocation(loc)
      //   let location: any = await getAddress(loc?.latitude, loc?.longitude);
      //   // orderLocationMethod({ ...location, cachedLocation })

      //   setSelectedAddress({
      //     locationName: location?.locationName,
      //     coordinates: {
      //       type: 'Point',
      //       coordinates: [loc.latitude, loc.longitude],
      //     },
      //   });
      //   setValue('address', location?.locationName);

      //   // updateCabService('pickup', {
      //   //   locationName: location?.locationName,
      //   //   coordinates: {
      //   //     type: 'Point',
      //   //     coordinates: [loc.latitude, loc.longitude],
      //   //   },
      //   // })
      //   handleClose();

      //   return;
      // }

      const { latitude, longitude }: any = await getCurrentLocation(() => {
        //  empty
        // setSelectedAddress({ address: '' });
        // setValue('address', '');
      });
      const currentLocation: any = { latitude, longitude };
      localStorage.setItem('userLocation', JSON.stringify(currentLocation));
      const location: any = await getAddress(
        currentLocation?.latitude,
        currentLocation?.longitude,
      );

      setSelectedAddress({
        locationName: location?.locationName,
        coordinates: {
          type: 'Point',
          coordinates: [currentLocation.latitude, currentLocation.longitude],
        },
      });
      setValue('address', location?.locationName);

      // updateCabService('pickup', {
      //   locationName: location?.locationName,
      //   coordinates: {
      //     type: 'Point',
      //     coordinates: [currentLocation.latitude, currentLocation.longitude],
      //   },
      // })
      handleClose();
      //   setLocation(currentLocation)
      // setError(null);
    } catch (err: any) {
      // setError(err.message)
      // console.log('Err', err.message)
      // notify(err.message, 'error');
      if (click) {
        setOpenLocationDeniedModal(true);
      }
      if (err.message !== 'Timeout Expired') {
        // notify(err.message, 'error');
      }
    }
  };

  const businessAddressesFilter = useMemo(() => {
    return (
      businessAddress?.data
        ?.filter((item: any) => item.addressType === addressType)
        ?.filter(
          (item: any) =>
            item?.locationName?.toLowerCase().includes(debouncedSearchKey) ||
            item?.setName?.toLowerCase().includes(debouncedSearchKey) ||
            item?.productionName?.toLowerCase().includes(debouncedSearchKey) ||
            item?.episodeNumber?.toLowerCase().includes(debouncedSearchKey) ||
            item?.episodeName?.toLowerCase().includes(debouncedSearchKey),
        )
        ?.reverse() || []
    );
  }, [businessAddress?.data, addressType, debouncedSearchKey]);

  console.log('GET', getValues(), businessAddressesFilter);
  const formatNames = (arr: string[] | any) => {
    if (!arr || arr.length === 0) return { text: '', extraCount: 0 };
    if (arr.length <= 1) return { text: arr.join(', '), extraCount: 0 };

    return { text: `${arr[0]}`, extraCount: arr.length - 1 };
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        handleClose();
        setSearchKey('');
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className="dialogWrapper warning orderAddress w__600">
        <div className="dialogHeader flex sps_between">
          <h4 className="small fw500 text-gray_700">Search Address</h4>
          <IconButton
            onClick={() => {
              handleClose();
              setSearchKey('');
            }}
          >
            <img src={Images.CLOSE} alt={tC('close')} />
          </IconButton>
        </div>
        <div className="doalogBody small">
          <div className="formContainer">
            <div className="">
              <Grid container spacing={2}>
                {/* <Grid item md={12} xs={12}>
                  <div className="addressType">
                    <RadioGroup
                      aria-labelledby="radio-buttons-group-label"
                      defaultValue="Set Address"
                      name="radio-buttons-group"
                      row
                    >
                      <FormControlLabel
                        value="Set Address"
                        control={<Radio />}
                        label="Set Address"
                        onChange={() => setAddressType('BUSINESS')}
                      />
                      <FormControlLabel
                        value="Personal Address"
                        control={<Radio />}
                        label="Personal Address"
                        onChange={() => setAddressType('PERSONAL')}
                      />
                    </RadioGroup>
                  </div>
                </Grid> */}
                <Grid item md={12} xs={12}>
                  <div className="addNewAddress">
                    {/* { address: businessAddressesFilter?.[0] } */}
                    {true && (
                      <>
                        <div className="left-icon">
                          <AutoCompleteLocation
                            //   requiredField
                            id="addressLocation"
                            // labelText={'Select Address'}
                            placeHolderText={'Search for address manually..'}
                            name="address"
                            control={control}
                            setValue={setValue}
                            limit={100}
                            setLatLong={setLatLong}
                            changeCallBack={(result: any, newV: any) => {
                              //   setDetails(result)

                              if (result) {
                                const locationData = {
                                  locationName: newV?.description,
                                  coordinates: {
                                    type: 'Point',
                                    coordinates: [
                                      result?.geometry?.location?.lat(),
                                      result?.geometry?.location?.lng(),
                                    ],
                                  },
                                };
                                // updateCabService(pickupType, locationData)
                                console.log('result', newV);
                                newV && setSelectedAddress(locationData);

                                if (result?.address_components) {
                                  handleClose();
                                }
                              }
                              // updateCabService
                            }}
                            defaultValue={getValues('address')}
                            isObject={true}
                            error={!!errors['address']}
                            helperText={
                              !!errors['address']
                                ? errors['address'].message
                                : ''
                            }
                          />
                        </div>

                        <hr className="dotted mb-6 mt-12" />

                        {pickupType === 'pickup' && (
                          <CustomButton
                            id=""
                            text="Current Location"
                            onClick={() => {
                              // navigate('/location')
                              // updateCabService(pickupType, locationData)
                              fetchLocation(true);
                            }}
                            variant="text"
                            showIcon
                            iconPosition="start"
                            icon={Images.Add_Ic}
                            iconType="image"
                            width="auto"
                            isMobileTextVisible={true}
                          />
                        )}

                        <hr className="dotted mt-6 mb-24" />
                      </>
                    )}

                    <div>
                      <h2 className="MuiTypography-body1 fw600 mb-12">
                        Saved Addresses
                      </h2>
                      <SearchInput
                        placeholder={'Search from a saved addresses'}
                        className="sm outlined"
                        // setQuery={(value: any) => onSearch(value)}
                        setSearchKey={setSearchKey}
                        searchkey={searchKey}
                        handleClearSearch={() => {
                          setSearchKey('');
                        }}
                      />
                    </div>

                    {/* <CustomButton
                      id=""
                      text="Add new address"
                      onClick={() => {
                        navigate('/location')
                      }}
                      variant="text"
                      showIcon
                      iconPosition="start"
                      icon={Images.Add_Ic}
                      iconType="image"
                      width="auto"
                    /> */}

                    {/* <AutoCompleteLocation
                      requiredField
                      id="addressLocation"
                      labelText={tC('address')}
                      placeHolderText={tC('enter_address')}
                      name="address"
                      control={control}
                      setValue={setValue}
                      limit={100}
                      setLatLong={setLatLong}
                      changeCallBack={(result: any) => {
                        setDetails(result)
                      }}
                      defaultValue={watch('address')}
                      isObject={true}
                      error={!!errors['address']}
                      helperText={
                        !!errors['address'] ? errors['address'].message : ''
                      }
                    /> */}
                  </div>
                </Grid>
                <Grid item md={12} xs={12}>
                  {addressType === 'BUSINESS' ? (
                    <div className="savedAddress">
                      {/* <h3>Saved Address</h3> */}

                      <ul>
                        {businessAddressesFilter?.length > 0 ? (
                          businessAddressesFilter?.map(
                            (item: any, i: number) => {
                              return (
                                <li onClick={() => handleLocation(item)}>
                                  <figure>
                                    <img
                                      src={Images.Drop_Map_Ic}
                                      alt="Location"
                                    />
                                  </figure>
                                  <div className="text">
                                    <h4>{item?.productionName}</h4>
                                    {item?.episodeName ? (
                                      <h3>
                                        {item?.episodeNumber
                                          ? `${item?.episodeNumber} - `
                                          : ''}{' '}
                                        {item?.episodeName}
                                      </h3>
                                    ) : null}
                                    <h3>{item?.setName?.toUpperCase()}</h3>
                                    {item?.locationPurpose?.length
                                      ? (() => {
                                          const { text, extraCount } =
                                            formatNames(item?.locationPurpose);
                                          return (
                                            <>
                                              <div className="d-flex align-center mb-4">
                                                <p className="text-text MuiTypography-subtitle1 fw600 text-black100">
                                                  {text}
                                                  {extraCount > 0 ? (
                                                    <ToolTipComponent
                                                      theme="light"
                                                      title={Object.entries(
                                                        item?.locationPurpose,
                                                      )
                                                        .slice(1) // Get all remaining key-value pairs
                                                        .map(
                                                          ([_, value]) =>
                                                            `${value}`,
                                                        )
                                                        .join(', ')}
                                                    >
                                                      <span className="tooltip-label ml-10">
                                                        +{extraCount}
                                                      </span>
                                                    </ToolTipComponent>
                                                  ) : null}
                                                </p>
                                              </div>
                                            </>
                                          );
                                        })()
                                      : null}
                                    <p>{item?.locationName}</p>
                                  </div>
                                </li>
                              );
                            },
                          )
                        ) : (
                          <NoData heading="No Address found." />
                        )}
                      </ul>
                    </div>
                  ) : (
                    <div className="savedAddress">
                      {/* <h3>Saved Address</h3> */}

                      <ul>
                        {businessAddresses?.map((item: any, i: number) => {
                          return (
                            <li>
                              <figure>
                                <img src={Images.Drop_Map_Ic} alt="Location" />
                              </figure>
                              <div className="text">
                                <h4>{item?.buildingName}</h4>
                                <h3>{item?.apartment}</h3>
                                {item?.locationPurpose?.length
                                  ? (() => {
                                      const { text, extraCount } = formatNames(
                                        item?.locationPurpose,
                                      );
                                      return (
                                        <>
                                          <div className="d-flex align-center mb-4">
                                            <p className="text-text MuiTypography-subtitle1 fw600 text-black100">
                                              {text}
                                              {extraCount > 0 ? (
                                                <ToolTipComponent
                                                  theme="light"
                                                  title={Object.entries(
                                                    item?.locationPurpose,
                                                  )
                                                    .slice(1) // Get all remaining key-value pairs
                                                    .map(
                                                      ([_, value]) =>
                                                        `${value}`,
                                                    )
                                                    .join(', ')}
                                                >
                                                  <span className="tooltip-label ml-10">
                                                    +{extraCount}
                                                  </span>
                                                </ToolTipComponent>
                                              ) : null}
                                            </p>
                                          </div>
                                        </>
                                      );
                                    })()
                                  : null}
                                <p>{item?.addressLabel}</p>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                </Grid>
              </Grid>
            </div>
          </div>
          <LocationDeniedModal
            open={openLocationDeniedModal}
            onCancel={() => setOpenLocationDeniedModal(false)}
            onConfirm={() => setOpenLocationDeniedModal(false)}
          />
        </div>
      </div>
    </Dialog>
  );
}

export default memo(SelectAddressDialog);
